import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { MobileAppBannerWidget } from '../../../core/models';
import { environment } from '../../../environments/environment';
import { CmsImagePipe } from '@selfcare/cms';
import { Store } from '@ngrx/store';
import { userFeature } from '@src/state';
import { isWidgetVisible } from '@core/helpers';

@Component({
  selector: 'sc-mobile-app-banner-widget',
  imports: [CmsImagePipe],
  templateUrl: './mobile-app-banner-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileAppBannerWidgetComponent {
  public data = input<MobileAppBannerWidget>(null);

  private readonly store = inject(Store);

  public isB2B = this.store.selectSignal(userFeature.selectIsB2B);
  public activeProduct = this.store.selectSignal(userFeature.selectActiveProduct);


  public isVisible = computed(() => {
    const bannerData = this.data();
    if (!bannerData) {
      return false;
    }

    return isWidgetVisible(bannerData, this.activeProduct(), this.isB2B());
  });

  public getBackgroundStyle() {
    const bannerData = this.data();
    if (!bannerData?.primaryBackgroundImage) {
      return '';
    }
    return `linear-gradient(-79.54deg, rgba(0, 0, 0, 0) 17.73%, #000000c2 88.19%), url(${environment.cms.apiUrl}${bannerData.primaryBackgroundImage?.url})`;
  }
}
